import useId from '../utils/useId';
import * as React from 'react';
export const lightModeSvg = React.forwardRef(function lightModeSvgInner(
  props,
  ref,
) {
  const id_0 = useId();
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement(
      'g',
      {
        clipPath: `url(#is_lightMode__a_${id_0})`,
      },
      /*#__PURE__*/ React.createElement('circle', {
        cx: 8,
        cy: 8,
        r: 3.25,
        stroke: '#474E5A',
        strokeWidth: 1.5,
      }),
      /*#__PURE__*/ React.createElement('path', {
        d: 'M8.75 2.25a.75.75 0 0 1-1.5 0V.75a.75.75 0 0 1 1.5 0v1.5Zm5 6.5a.75.75 0 0 1 0-1.5h1.5a.75.75 0 0 1 0 1.5h-1.5Zm-1.154-4.285a.75.75 0 0 1-1.06-1.061l1.06-1.06a.75.75 0 1 1 1.06 1.06l-1.06 1.06ZM4.465 3.404a.75.75 0 0 1-1.061 1.06l-1.06-1.06a.75.75 0 1 1 1.06-1.06l1.06 1.06ZM8.75 15.25a.75.75 0 0 1-1.5 0v-1.5a.75.75 0 0 1 1.5 0v1.5Zm-8-6.5a.75.75 0 0 1 0-1.5h1.5a.75.75 0 0 1 0 1.5H.75Zm2.654 4.907a.75.75 0 1 1-1.06-1.06l1.06-1.061a.75.75 0 0 1 1.06 1.06l-1.06 1.06Zm10.253-1.061a.75.75 0 0 1-1.06 1.06l-1.061-1.06a.75.75 0 1 1 1.06-1.06l1.06 1.06Z',
      }),
    ),
    /*#__PURE__*/ React.createElement(
      'defs',
      null,
      /*#__PURE__*/ React.createElement(
        'clipPath',
        {
          id: `is_lightMode__a_${id_0}`,
        },
        /*#__PURE__*/ React.createElement('path', {
          d: 'M0 0h16v16H0z',
        }),
      ),
    ),
  );
});
lightModeSvg.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
};
export var lightMode = {
  category: 'icon',
  colorable: true,
  name: 'lightMode',
  svg: lightModeSvg,
};
